/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step2_TitleInputs */

const et_process_step2_title = /** @type {(inputs: Process_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02. Sisseastumine`)
};

const en_process_step2_title = /** @type {(inputs: Process_Step2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02. Onboarding`)
};

/**
* | output |
* | --- |
* | "02. Onboarding" |
*
* @param {Process_Step2_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step2_title = /** @type {((inputs?: Process_Step2_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step2_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step2_title(inputs)
	return en_process_step2_title(inputs)
});